import { ViewChild, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';

@Component({
    selector: 'common-document-warning-modal',
    templateUrl: 'common-document-warning-modal.component.html',
    styles: [`
    .modal-body .dropbox {
      font-size: 14px;
      border: 3px dashed #ededed;
      height: 90px;
      text-align: center;
      cursor: pointer;
      color: #999;
      padding-top: 20px;
      margin: 10px;
    }
    .modal-body .removeType {
      position: absolute;
      top: 15px;
      right: 18px;
      z-index: 10;
      color: silver;
    }
    .modal-body .drop-list {
      max-height: 150px;
      overflow: auto;
    }
    `]
})

export class CommonDocumentWarningComponent implements OnInit {

    @Input() modalDetails: any;
    @Output() outputEmit = new EventEmitter<any>();
    @ViewChild('commonDocumentUploadWarningModal', { static: true })
    commonDocumentUploadWarningModal: any;

    constructor(
        public  toastr: ToastService
    ) { }

    ngOnInit() {}
    modalInterVal: any
    ngOnChanges() {
        if (this.modalDetails && this.modalDetails.sprigNotAvailable) {
            this.commonDocumentUploadWarningModal.show();
            this.modalInterVal = setInterval(() => {
                this.checkSprigAvailable();
            }, 700);
        }
    }

    isLoading: boolean = false;
    checkSprigAvailable() {
        const getLocalSprig = localStorage.getItem('selectedDevice')
        const getSelectedSprig = getLocalSprig ? JSON.parse(getLocalSprig) : null;

        if (getSelectedSprig && getSelectedSprig.basePathUrl && getSelectedSprig.installationId) {
            this.commonDocumentUploadWarningModal.hide();
            clearInterval(this.modalInterVal)
        }

    }

    checkSprig() {
        this.isLoading = true;
        this.outputEmit.emit(true);
        setTimeout(() => {
            this.isLoading = false;
        }, 1000);
    }

}
